import React, { useEffect } from 'react';
import { Button, Form, Input, notification } from 'antd';
import { AuthApi } from 'api/api';
import Heading from 'components/heading/heading';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useNavigate } from 'react-router-dom';
import openNotificationWithIcon from 'utility/notification';
import { AuthWrapper } from './style';
import styled from 'styled-components';

const authApi = new AuthApi();

const CenteredContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`;

const FormContainer = styled.div`
  width: 100%;
  max-width: 400px;
  text-align: center;
`;

const Logo = styled.img`
  max-width: 200px;
  height: auto;
  margin-bottom: 24px;
`;

function ForgotPassword() {
  /**
   * Forms
   */
  const [form] = Form.useForm();

  /**
   * Translation
   */
  const { t, i18n } = useTranslation();

  /**
   * React router dom
   */
  const navigate = useNavigate();

  /**
   * States
   */
  const [state, setState] = useState({
    values: null,
  });
  const [loading, setLoading] = useState(false);
  const [showMobileReturn, setShowMobileReturn] = useState(false);
  const isMobile = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  /**
   *
   * @param values any
   */
  const handleSubmit = async (values: any) => {
    setLoading(true);
    try {
      await authApi.apiAuthForgotPasswordPost({
        forgotPasswordCommand: form.getFieldsValue(),
      });
      setState({ ...state, values });
      if (isMobile) {
        setShowMobileReturn(true);
      } else {
        openNotificationWithIcon(
          'success',
          t('forgot-password:notification.success.title', 'Instructions sent to your email'),
          t(
            'forgot-password:notification.success.description',
            "If you don't receive the email within a few minutes, please check your spam folder!",
          ),
        );
        navigate('/');
      }
    } catch (error) {
      notification.destroy();
      openNotificationWithIcon(
        'success',
        t(
          'forgot-password:email.not.found.error',
          'If the email address provided is correct, you will receive a message in your inbox',
        ),
      );
    } finally {
      setLoading(false);
    }
  };

  const handleMobileReturn = () => {
    window.location.href = 'adriaticproject://';
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    // Handle email param
    const email = params.get('email');
    if (email) {
      form.setFieldValue('email', email);
    }

    // Handle language param
    const lang = params.get('lang');
    if (lang) {
      i18n.changeLanguage(lang);
    }
  }, [form, i18n]);

  if (showMobileReturn) {
    return (
      <CenteredContainer>
        <FormContainer>
          <Logo src={require('../../static/img/org-logo/adriatic-project-logo.png')} alt="Logo" />
          <p style={{ margin: '20px 0', textAlign: 'center' }}>
            {t('forgot-password:notification.success.title', 'Instructions sent to your email')}
            <br />
            <small style={{ color: '#666' }}>
              {t(
                'forgot-password:notification.success.description',
                "If you don't receive the email within a few minutes, please check your spam folder!",
              )}
            </small>
          </p>
          <Button type="primary" size="large" onClick={handleMobileReturn}>
            {t('forgot-password:return.to.app', 'Kthehu tek aplikacioni mobil')}
          </Button>
        </FormContainer>
      </CenteredContainer>
    );
  }

  return (
    <AuthWrapper>
      <CenteredContainer>
        <FormContainer>
          <Logo src={require('../../static/img/org-logo/adriatic-project-logo.png')} alt="Logo" />
          <Form name="forgotPass" onFinish={handleSubmit} layout="vertical" form={form}>
            <Heading as="h3">{t('forgotPassword.title', 'Forgot Password?')}</Heading>
            <p className="forgot-text">
              {t(
                'forgotPassword.description',
                "Enter the email address you used when you joined and we'll send you instructions to reset your password.",
              )}
            </p>
            <Form.Item
              label={t('forgotPassword.input.email', 'Email Address')}
              name="email"
              rules={[
                {
                  required: true,
                  message: t('forgotPassword.error.email', 'Please input your email!'),
                  type: 'email',
                },
              ]}
            >
              <Input placeholder={t('forgotPassword.placeholder.email', 'name@example.com')} />
            </Form.Item>
            <Form.Item>
              <Button className="btn-reset" htmlType="submit" loading={loading} type="primary" size="large">
                {t('forgotPassword.button.send', 'Send Reset Instructions')}
              </Button>
            </Form.Item>
            <p className="return-text">
              {t('global:return.to', 'Return to')} <NavLink to="/">{t('signIn.signIn', 'Sign In')}</NavLink>
            </p>
          </Form>
        </FormContainer>
      </CenteredContainer>
    </AuthWrapper>
  );
}

export default ForgotPassword;
